import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=37e38fb8&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports